exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".org-main[data-v-74f6ac66]{height:99%;border-top:1px solid #dedede}.div-top[data-v-74f6ac66]{display:flex;padding:.375rem .625rem;align-items:center;height:2.875rem}.div-top .org-name[data-v-74f6ac66]{flex:2;font-size:14px;font-weight:bolder;color:#464646;margin-left:.375rem}.div-top .filter[data-v-74f6ac66]{text-align:right;flex:1}.div-top .filter span[data-v-74f6ac66]{font-size:.875rem}.div-top .filter img[data-v-74f6ac66]{width:1.25rem;vertical-align:middle}.cont-list[data-v-74f6ac66]{overflow:auto;flex:1;height:100%}[data-v-74f6ac66] .van-list{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74f6ac66","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/content/invested/InvestedList.vue
// module id = 829
// module chunks = 0